<template>
	<div class="container py-5">
        <h2>{{ $t('modelingImport') }}</h2>
        <input type="file" class="form-control" multiple="true" @change="onFileChanged($event)"/>
        <div class="container mt-4" v-if="importAssetTypes.length > 0">  
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">{{ $t('assetTypes' )}}</label>
                </div>
                <div class="col-md-6">
                    <label class="form-label">{{ $t('datasets' )}}</label>
                </div>
            </div>
            <div class="row" v-for="(assetType, i) in importAssetTypes" :key="i">
                <div class="col-md-6">
                    <div class="input-group mb-3">
                        <div class="input-group-text">
                            <input class="form-check-input mt-0" type="checkbox" v-model="assetType.checked">
                        </div>
                        <input type="text" class="form-control" v-model="assetType.name" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="input-group mb-3">
                        <select class="form-select" v-model="assetType.dataset">
                            <option v-for="(dataset, o) in importDatasetList" v-bind:value="'-' + dataset.number" :key="o">*{{dataset.name}} </option>
                            <option v-for="(dataset, u) in datasetList" v-bind:value="dataset.id" :key="u">Attach to {{dataset.name}} </option>
                        </select>
                    </div>
                </div>
            </div>
            <label class="form-label">{{ $t('forecasts' )}}</label>
            <div class="row" v-for="(forecast, i) in importForecastList" :key="i">
                <div class="col-md-6">
                    <div class="input-group mb-3">
                        <div class="input-group-text">
                            <input class="form-check-input mt-0" type="checkbox" v-model="forecast.checked">
                        </div>
                        <input type="text" class="form-control" v-model="forecast.name" disabled>
                    </div>
                </div>
            </div>
            <label class="form-label">{{ $t('selections' )}}</label>
            <div class="row" v-for="(selection, i) in importSelections" :key="i">
                <div class="col-md-6">
                    <div class="input-group mb-3">
                        <div class="input-group-text">
                            <input class="form-check-input mt-0" type="checkbox" v-model="selection.checked" :disabled="!isSelectionDisabled(selection)">
                        </div>
                        <input type="text" class="form-control" v-model="selection.name" disabled>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-grid gap-2 d-md-flex mt-4">
            <button type="button" class="btn btn-primary" @click="confirm">{{ $t('upload') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}` })">{{ $t('back') }}</button>
        </div>
    </div>
</template>

<script>
import ModelingApi from "../../api/server/modeling";
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ForecastApi from "../../api/server/forecast";
import SelectionApi from "../../api/server/selection";
import AnalysisApi from "../../api/server/analysis";

export default {
    name: "modelingimport",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        isSelectionDisabled(selection) {
            var foundForecast = this.importForecastList.find(f => f.checked && "-" + f.number == selection.forecast);
            return foundForecast != null;
        },
        async requestData() {
            this.data = await ModelingApi.modelingDetail(this.$route.params.id);
            this.datasetList = await DatasetApi.datasetList(this.$route.params.id);
            this.assetTypeList = await AssetTypeApi.assetTypeList(this.$route.params.id);
            this.forecastList = await ForecastApi.forecastList(this.$route.params.id);
            this.selectionList = await SelectionApi.selectionList(this.$route.params.id);
            this.analysisList = await AnalysisApi.analysisList(this.$route.params.id);
            
            this.pending = false;
        },
        onFileChanged(event) {
            const file = event.target.files[0];
            if (file && file.type === "application/json") {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        var fileContent = JSON.parse(e.target.result);

                        if(fileContent.assetTypes) {
                            for(var i in fileContent.assetTypes) {
                                var assetType = fileContent.assetTypes[i];
                                assetType.checked = false;

                                this.importAssetTypes.push(assetType)
                            }
                        }
                        if(fileContent.datasets) {
                            this.importDatasetList = fileContent.datasets;
                        }

                        if(fileContent.selections) {
                            for(var i in fileContent.selections) {
                                var selection = fileContent.selections[i];
                                selection.checked = false;

                                this.importSelections.push(selection)
                            }
                        }
                        if(fileContent.forecasts) {
                            for(var i in fileContent.forecasts) {
                                var forecast = fileContent.forecasts[i];
                                forecast.checked = false;

                                this.importForecastList.push(forecast)
                            }
                            // this.importForecastList = fileContent.forecasts;
                        }
                        
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                    }
                };
                reader.readAsText(file);
            } else {
                console.error("Please select a valid JSON file.");
            }
        },
        async confirm() {
            var canUpload = true;

            var data = {
                datasets: this.importDatasetList,
                assetTypes: this.importAssetTypes.filter(c => c.checked),
                forecasts: this.importForecastList.filter(c => c.checked),
                selections: this.importSelections.filter(c => c.checked)
            };

            for(var i in data.forecasts) {
                var forecast = data.forecasts[i];
                for(var o in forecast.forecastLifeCycles) {
                    var lifeCycle = forecast.forecastLifeCycles[o];
                    if(data.assetTypes.find(a => a.number == lifeCycle.assetType) == null) {
                        canUpload = false;
                    }
                }
            }

            if(canUpload) {
                await ModelingApi.importJson(this.$route.params.id, data);
                this.$router.go(-1)
            } else {
                this.showError();
            }
        },
    },
    notifications: {
        showError: { 
            title: 'error',
            message: "importError",
            type: 'error'
        },
    },
    data() {
        return {
            data: {
                name: "",
                id: 0
            },
            datasetList: [],
            assetTypeList: [],
            forecastList: [],
            selectionList: [],
            analysisList: [],
            importAssetTypes: [],
            importDatasetList: [],
            importSelections: [],
            importForecastList: [],
            showImportModal: false,
            pending: true,
        }
    }
};
</script>